import { initializeApp } from "firebase/app";
import { getAuth,signInWithEmailAndPassword,onAuthStateChanged,signOut } from "firebase/auth";
import { getFirestore,collection, addDoc,getDocs,setDoc,deleteDoc,doc,query, where,serverTimestamp ,onSnapshot, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes,getDownloadURL,uploadBytesResumable } from "firebase/storage";
// const firebaseConfig = {
//   apiKey: "AIzaSyCvAO22_JAiDn6Ui6-_FTdBBhaB-JiZLqw",
//   authDomain: "react-266df.firebaseapp.com",
//   projectId: "react-266df",
//   storageBucket: "react-266df.appspot.com",
//   messagingSenderId: "480860030706",
//   appId: "1:480860030706:web:be40ce9e1d2d184ea7326b",
//   measurementId: "G-ZJXRDX7T5Q"
// };

const firebaseConfig={
  apiKey: "AIzaSyAMyPnigA82hTdQB9FIzoXeDd37C1jamZ8",
  authDomain: "batch9-983b4.firebaseapp.com",
  // databaseURL: "https://batch9-983b4-default-rtdb.firebaseio.com",
  projectId: "batch9-983b4",
  storageBucket: "batch9-983b4.appspot.com",
  messagingSenderId: "262976751573",
  appId: "1:262976751573:web:2b1260fd06c002c1365f5c"
}


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth=getAuth(app)
export {updateDoc,collection, addDoc,db,getDocs,serverTimestamp,deleteDoc,onAuthStateChanged,ref,auth,signOut,signInWithEmailAndPassword,uploadBytes,storage,getDownloadURL,uploadBytesResumable,setDoc,doc,query, where, onSnapshot,}